import React, { Fragment } from 'react'
import { Intro, MultipleChoice } from 'cvs-core'

const data = {
  question:
    'How do many e-cigarette companies use advertising practices to increase the market for their product?',
  inputType: 'radio',
  options: [
    {
      label: 'By providing FDA approved statistics about vaping benefits.',
    },
    {
      label: 'They emphasize disadvantages of using e-cigarettes.',
    },
    {
      label: 'By using misleading advertising practices that target teens.',
    },
    {
      label: 'They advertise through TV commercials and magazines.',
    },
  ],
}

const correctInput = {
  [data.question]: data.options[2].label,
}

const feedback = {
  success: {
    title: 'That’s right!',
    body:
      'E-cigarette companies use misleading practices that target adolescents to increase the market for their product.',
  },
  error: {
    title: 'Not quite.',
    body:
      'E-cigarette companies use misleading practices that target adolescents to increase the market for their product. You will learn more about this in the module.',
  },
}

export default {
  title: 'Question 4',
  path: '/prepare/question-4',
  content: (
    <Fragment>
      <Intro
        title="Question 4"
        direction={'Select the item that best completes the statement.'}
      />
      <MultipleChoice
        data={data}
        correctInput={correctInput}
        feedback={feedback}
      />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Prepare/Question4.js